module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M16 14H6v-4c0-3.308 2.692-6 6-6a6.01 6.01 0 0 1 5.67 4.04C18.034 9.082 18.894 10 20 10s2.022-.902 1.802-1.984C20.882 3.442 16.844 0 12 0 6.476 0 2 4.476 2 10v4c-1.106 0-2 .894-2 2v14c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V16c0-1.106-.894-2-2-2h-6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/unlock-1.js
// module id = 1465
// module chunks = 14